import { Link } from 'react-router-dom';
import type { ComicArticle } from '@/mocks/comics';

interface ComicCardProps {
  comic: ComicArticle;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.slug}`}
      className="group block"
      data-product-shop
    >
      <div className={`relative overflow-hidden rounded-lg ${size === 'large' ? 'aspect-[3/4]' : 'aspect-[2/3]'}`}>
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - 羞羞漫画热门推荐`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
        <div className="absolute top-2 left-2">
          {comic.status === 'completed' && (
            <span className="px-2 py-0.5 text-[10px] font-medium bg-accent-500 text-background-50 rounded-full">
              已完结
            </span>
          )}
          {comic.status === 'serializing' && (
            <span className="px-2 py-0.5 text-[10px] font-medium bg-primary-500 text-background-50 rounded-full">
              连载中
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-sm font-medium text-white line-clamp-1 mb-1">{comic.title}</h3>
          <div className="flex items-center gap-3 text-[11px] text-white/70">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
              {comic.rating}
            </span>
            <span>{comic.chapters}话</span>
          </div>
        </div>
      </div>
    </Link>
  );
}